import React, { createContext, useState, useContext } from "react";

interface GenerateDeliveryNoteActionContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  generatePdf: boolean;
  setGeneratePdf: (generate: boolean) => void;
  sendToCustomer: boolean;
  setSendToCustomer: (send: boolean) => void;
  separatedInvoices: boolean;
  setSeparatedInvoices: (separated: boolean) => void;
}

export const GenerateDeliveryNoteActionContext = createContext<GenerateDeliveryNoteActionContextType>({
  showModal: false,
  setShowModal: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  loading: false,
  setLoading: () => {},
  generatePdf: true,
  setGeneratePdf: () => {},
  sendToCustomer: false,
  setSendToCustomer: () => {},
  separatedInvoices: true,
  setSeparatedInvoices: () => {},
});

interface GenerateDeliveryNoteActionProviderProps {
  children: React.ReactNode;
}

export const GenerateDeliveryNoteActionProvider: React.FC<GenerateDeliveryNoteActionProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const [generatePdf, setGeneratePdf] = useState(true);
  const [sendToCustomer, setSendToCustomer] = useState(false);
  const [separatedInvoices, setSeparatedInvoices] = useState(true);

  const value = {
    showModal,
    setShowModal,    
    backendFormErrors,
    setBackendFormErrors,
    loading,
    setLoading,
    generatePdf,
    setGeneratePdf,
    sendToCustomer,
    setSendToCustomer,
    separatedInvoices,
    setSeparatedInvoices,
  };
  return (
    <GenerateDeliveryNoteActionContext.Provider value={value}>
      {children}
    </GenerateDeliveryNoteActionContext.Provider>
  );
};
